import { createSlice } from '@reduxjs/toolkit';
import { clearPermissions } from './permissionsSlice';

const initialState = {
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      // Clear ALL localStorage when logging out (not just tokens)
      localStorage.clear();
      sessionStorage.clear();
    },
  },
});

// Enhanced logout thunk that also clears permissions and all stored data
export const logoutUser = () => (dispatch) => {
  // Clear auth state
  dispatch(logout());
  // Clear permissions
  dispatch(clearPermissions());
  // Clear ALL stored data
  localStorage.clear();
  sessionStorage.clear();
};

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer; 